import React from "react";
import {
  BrowserRouter,
  Outlet,
  Route,
  Routes, useNavigate
} from "react-router-dom";
import * as Screen from "../screens";
import { SiteLayout } from "../components";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { CategoryList } from "@/screens/category";

export const RouterPage = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Auth />}>
          <Route
            path="*"
            element={
              <SiteLayout>
                <Screen.NotFound />
              </SiteLayout>
            }
          ></Route>
          <Route
            path=""
            element={
              <SiteLayout>
                <Screen.Home />
              </SiteLayout>
            }
          ></Route>
          <Route
            path="info"
            element={
              <SiteLayout>
                <Screen.Info />
              </SiteLayout>
            }
          ></Route>
          <Route path={"dashboard"}>
            <Route
              path="about-us"
              element={
                <SiteLayout>
                  <Screen.AboutUs />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="admin">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.AdminList />
                </SiteLayout>
              }
            />
            <Route
              path="new"
              element={
                <SiteLayout>
                  <Screen.AdminNew />
                </SiteLayout>
              }
            />
            <Route
              path="info/:id"
              element={
                <SiteLayout>
                  <Screen.AdminInfo />
                </SiteLayout>
              }
            />
            <Route
              path="edit/:id"
              element={
                <SiteLayout>
                  <Screen.AdminEdit />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="user">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.UserList />
                </SiteLayout>
              }
            />
            <Route
              path="info/:id"
              element={
                <SiteLayout>
                  <Screen.UserInfo />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="roles">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.RolesList />
                </SiteLayout>
              }
            />
            <Route
              path="permission"
              element={
                <SiteLayout>
                  <Screen.PermissionPage />
                </SiteLayout>
              }
            />
            <Route
              path=":id"
              element={
                <SiteLayout>
                  <Screen.EditRolesPage />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="category">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.CategoryList />
                </SiteLayout>
              }
            />
            <Route
              path="children/:id"
              element={
                <SiteLayout>
                  <Screen.CategoryChildren />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="pricing">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.PricingList />
                </SiteLayout>
              }
            />
            <Route
              path="new"
              element={
                <SiteLayout>
                  <Screen.PricingNew />
                </SiteLayout>
              }
            />
            <Route
              path="edit/:id"
              element={
                <SiteLayout>
                  <Screen.PricingEdit />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="publisher">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.PublisherList />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="product">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.ProductList />
                </SiteLayout>
              }
            />
            <Route
              path="new"
              element={
                <SiteLayout>
                  <Screen.ProductNew />
                </SiteLayout>
              }
            />
            <Route
              path="info/:id"
              element={
                <SiteLayout>
                  <Screen.ProductInfo />
                </SiteLayout>
              }
            />
            <Route
              path="edit/:id"
              element={
                <SiteLayout>
                  <Screen.ProductEdit />
                </SiteLayout>
              }
            />
          </Route>

          <Route path="product">
            <Route
              path=""
              element={
                <SiteLayout>
                  <Screen.ProductList />
                </SiteLayout>
              }
            />
            <Route
              path="new"
              element={
                <SiteLayout>
                  <Screen.ProductNew />
                </SiteLayout>
              }
            />
            <Route
              path="info/:id"
              element={
                <SiteLayout>
                  <Screen.ProductInfo />
                </SiteLayout>
              }
            />
            <Route
              path="edit/:id"
              element={
                <SiteLayout>
                  <Screen.ProductEdit />
                </SiteLayout>
              }
            />
          </Route>

        </Route>
        <Route path="/login" element={<Screen.Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export const Auth: React.FC = () => {
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);
  React.useEffect(() => {
    if (
      user === undefined ||
      user?.accessToken === undefined ||
      user?.accessToken == ""
    ) {
      navigate("/login", { replace: false });
    }
  });

  return <Outlet />;
};
